var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.407 2.04887C11.407 2.04887 16.5244 -2.27572 20.6264 1.64089C24.1192 4.98633 23.0632 10.0861 19.1237 14.4515C15.0623 18.9393 11.407 20 11.407 20C11.407 20 7.71108 18.9393 3.64966 14.4515C-0.33053 10.0861 -1.3865 4.98633 2.14694 1.64089C6.28958 -2.27572 11.407 2.04887 11.407 2.04887Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6925 13.8479C10.0467 13.8156 10.3578 13.6018 10.5172 13.2848L10.5175 13.2842L12.8801 8.55517L14.2123 10.333C14.2124 10.3332 14.2125 10.3333 14.2126 10.3334C14.4061 10.5927 14.7111 10.7444 15.0339 10.7444H17.3631C17.9299 10.7444 18.3895 10.2842 18.3895 9.71747C18.3895 9.15069 17.9299 8.69054 17.3631 8.69054H15.5471L13.5258 5.99369L13.5257 5.99357C13.3122 5.70902 12.9698 5.55622 12.6133 5.58688L12.6124 5.58697C12.2576 5.61886 11.946 5.83277 11.7864 6.15017L11.7861 6.15076L9.42349 10.8798L8.09092 9.1014L8.0909 9.10138C7.89697 8.84263 7.59305 8.69054 7.26972 8.69054H4.94048C4.37367 8.69054 3.91406 9.15069 3.91406 9.71747C3.91406 10.2842 4.37367 10.7444 4.94048 10.7444H6.75646L8.77779 13.4412L8.77788 13.4414C8.97277 13.701 9.27754 13.8521 9.59896 13.8521C9.62726 13.8521 9.6589 13.8512 9.6925 13.8479ZM9.6925 13.8479C9.69208 13.8479 9.69165 13.8479 9.69123 13.848L9.66884 13.599L9.69373 13.8477C9.69332 13.8478 9.69291 13.8478 9.6925 13.8479Z",
    fill: "white",
    stroke: "#171717",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLife);
export default __webpack_public_path__ + "static/media/Life.7632f53f5dc376f1cd745538b3645ab3.svg";
export { ForwardRef as ReactComponent };